import { DisruptionFormValues } from '@/pages/Disruptions/types'
import { useFieldArray, UseFormReturn } from 'react-hook-form'
import { Input } from '@/ui/Input'
import styles from './DiversionRouteSelector.module.scss'
import { useDisruptionsTableFormStateStore } from '@/pages/Disruptions/store'
import { SuggestionInputTable } from '@/ui/SuggestionInputTable'

export const DiversionRouteContainer = ({ form }: { form: UseFormReturn<DisruptionFormValues> }) => {
    const { selectedRoutes = [] } = useDisruptionsTableFormStateStore()
    const { fields, append } = useFieldArray({
        name: 'diversionRoutes',
        control: form.control,
    })

    const appendNextDiversionRoute = (index: number) => {
        if (!fields[index + 1]) {
            append(
                {
                    diversion: '',
                    route: '',
                },
                { shouldFocus: false }
            )
        }
    }

    if (selectedRoutes.length <= 1) {
        return (
            <Input
                {...form.register('diversionRoutes.0.diversion')}
                variant="table"
                type="text"
                transparent
                fullWidth
                className={styles.diversionInput}
                maxLength={200}
                placeholder={'Diversion / mitigation'}
            />
        )
    }

    return (
        <>
            {fields.map((field, index) => (
                <div key={field.id} className={styles.diversionContainer}>
                    <SuggestionInputTable
                        variant="table"
                        className={styles.routeSuggestionMenu}
                        inputClassName={styles.routeInput}
                        transparent
                        fullWidth
                        options={selectedRoutes
                            .filter((route) => !fields.map((field) => field.route).includes(route))
                            .map((route) => ({
                                id: route,
                                value: route,
                                label: route,
                            }))}
                        onChange={(routes) => {
                            form.setValue(`diversionRoutes.${index}.route`, routes)
                        }}
                        value={form.watch(`diversionRoutes.${index}.route`)}
                        onFocus={() => {
                            appendNextDiversionRoute(index)
                        }}
                        placeholder="Route"
                    />

                    <div className={styles.diversionInputContainer}>
                        <Input
                            {...form.register(`diversionRoutes.${index}.diversion`)}
                            variant="table"
                            type="text"
                            transparent
                            fullWidth
                            className={styles.diversionInput}
                            placeholder={'Diversion / mitigation'}
                            maxLength={200}
                        />
                    </div>
                </div>
            ))}
        </>
    )
}
